export default __webpack_public_path__ + "static/media/analiseIcone.dd18ea88.svg";